/** Global middleware: Applies authentication and legacy redirect checks */
import { AppRoute } from '@ts-routes/enums'

import { useMiddlewareAuth } from '@composables/middleware/authenticated.hook'
import { useMiddlewareAutoLogin } from '@composables/middleware/auto-login.hook'
import { useMiddlewareScopeFallback } from '@composables/middleware/scope-fallback.hook'

import { defineNuxtRouteMiddleware } from '#app'

// FIXME: auth.ts
export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path.startsWith('/dev/preview')) {
    return
  }

  const signature = (to.query?.signature as string | undefined) ?? undefined

  if (signature) {
    const autoLoginTarget = await useMiddlewareAutoLogin(to, signature)
    if (autoLoginTarget) return navigateTo(autoLoginTarget, { replace: true })
    return navigateTo(AppRoute.Login)
  }

  const authResult = await useMiddlewareAuth(to)
  if (authResult) return authResult

  useMiddlewareScopeFallback(to)
})
